import axios from 'axios';
import i18n from '../lib/i18n.js';

const axiosClient = axios.create({
  baseURL: ''
});

// NOTE: Pede json como retorno
axiosClient.defaults.headers.common['Accept'] = 'application/json';

// Repassa o idioma ativo da SPA para o Rails via header (ApplicationController
// #set_locale lê X-Locale). Interceptor em vez de defaults.headers.common fixo:
// lido a cada request, então funciona mesmo se o request disparar antes do
// initI18n rodar no entrypoint, e já reflete trocas feitas em runtime pelo
// LanguageSwitcher.
axiosClient.interceptors.request.use((config) => {
  if (i18n.language) config.headers['X-Locale'] = i18n.language;

  // X-CSRF-Token em requests de escrita: o upload multipart não é format
  // :json garantido no Rails (protect_from_forgery) — lido a cada request
  // porque o token troca a cada sessão (doc 10, gap §3).
  const method = (config.method || 'get').toLowerCase();
  if (method !== 'get' && method !== 'head') {
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    if (token) config.headers['X-CSRF-Token'] = token;
  }

  return config;
});

// NOTE: Qualquer header pode ser configurado para ser utilizado sempre
// mainAxios.defaults.headers.common['api-key'] = 'abc';

// NOTE:
// Esta configuração monitora as respostas das requisições
// Se receber alguma resposta com status 401 entendo que o customer não está logado
// Sendo assim redireciono para a raiz (/), que é a tela de acesso do Customer
axiosClient.interceptors.response.use(function (response) {
  console.debug('Request Successful!', response);
  return response.data;
}, function (error) {
  console.error('Request Failed:', error.config);

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 401) {
      window.location = '/';
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    // if (error.message == 'Network Error') {
      // You can treat network error globally here
    // }
    console.log(error.message);
    console.log(error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
  }
  
  return Promise.reject(error.response || error.message);
});

export default axiosClient;